import View from './views/View'

const route = {
    // exact: true,
    purePath: '/terms',
    path: '/:lang/terms',
    component: View
}

export default route